import { AdminStickersApi } from '~/Providers/Api';
import { success, error } from '~/Redux/Modules/Notifications';
import { parseErrors } from '~/Redux/Helpers';

const FETCH = 'artful-client/Admin/Stickers/FETCH';
const FETCH_SUCCESS = 'artful-client/Admin/Stickers/FETCH_SUCCESS';
const FETCH_FAILURE = 'artful-client/Admin/Stickers/FETCH_FAILURE';

const STORE = 'artful-client/Admin/Stickers/STORE';
const STORE_SUCCESS = 'artful-client/Admin/Stickers/STORE_SUCCESS';
const STORE_FAILURE = 'artful-client/Admin/Stickers/STORE_FAILURE';

const DELETE = 'artful-client/Admin/Stickers/DELETE';
const DELETE_SUCCESS = 'artful-client/Admin/Stickers/DELETE_SUCCESS';
const DELETE_FAILURE = 'artful-client/Admin/Stickers/DELETE_FAILURE';

const UPDATE_FORM = 'artful-client/Admin/Stickers/UPDATE_FORM';

const CLEAR = 'artful-client/Admin/Stickers/CLEAR';

const initialState = {
  isFetching: false,
  isAdding: false,
  isDeleting: false,
  hasFetched: false,
  data: {
    current_page: 1,
    per_page: 20,
    total: 20,
    data: [],
  },
  error: '',
  actionSticker: {
    name: '',
    image: false,
  },
  actionId: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH:
      return { ...state, isFetching: true, hasFetched: false };
    case FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        hasFetched: true,
        data: action.data,
      };
    case FETCH_FAILURE:
      return {
        ...state,
        isFetching: false,
        hasFetched: true,
        error: action.error,
      };

    case STORE:
      return { ...state, isAdding: true };
    case STORE_SUCCESS:
      return {
        ...state,
        isAdding: false,
        actionSticker: initialState.actionSticker,
        data: { ...state.data, data: [...state.data.data, action.data] },
      };
    case STORE_FAILURE:
      return { ...state, isAdding: false, error: action.error };

    case DELETE:
      return { ...state, isDeleting: true, actionId: action.actionId };
    case DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        actionId: false,
        data: {
          ...state.data,
          data: state.data.data.filter(s => s.id !== action.data.id),
        },
      };
    case DELETE_FAILURE:
      return { ...state, isDeleting: false, error: action.error };

    case UPDATE_FORM:
      return {
        ...state,
        actionSticker: { ...state.actionSticker, ...action.update },
      };

    case CLEAR:
      return initialState;
    default:
      return state;
  }
}

export const getStickers = (page = 1, search = '') => async dispatch => {
  dispatch({ type: FETCH });
  try {
    let response = await AdminStickersApi.fetch(page, search);
    dispatch({ type: FETCH_SUCCESS, data: response.data });
    return response;
  } catch (err) {
    dispatch({ type: FETCH_FAILURE, error: err });
  }
};

export const deleteSticker = id => async dispatch => {
  dispatch({ type: DELETE, actionId: id });
  try {
    let response = await AdminStickersApi.delete(id);
    dispatch({ type: DELETE_SUCCESS, data: response.data });
    dispatch(success('Sticker Deleted!'));
    return response;
  } catch (err) {
    dispatch({ type: DELETE_FAILURE, error: err });
  }
};

export const addSticker = data => async dispatch => {
  dispatch({ type: STORE });
  try {
    let response = await AdminStickersApi.store(data);
    dispatch({ type: STORE_SUCCESS, data: response.data });
    dispatch(success('Sticker Added!'));
    return response;
  } catch (err) {
    dispatch({ type: STORE_FAILURE, error: err });
    dispatch(error('Sticker not added', parseErrors(err)));
  }
};

export const updateForm = update => dispatch => {
  dispatch({ type: UPDATE_FORM, update });
};

export const clear = () => dispatch => {
  dispatch({ type: CLEAR });
};
